<template>
    <div class="course_main">
        <div v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><img src="@/Images/nav_close.png"/></div>
            <div class="title"></div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>

        <div class="content" v-if="courseType === 8">
            <div class="ws_title">下载全部PDF资料包</div>
            <div class="ws_des">百度云盘链接：</div>
            <div class="ws_url" v-html="geneBaiduUrl()"></div>
            <div class="ws_code">提取码：{{geneBaiduCode()}}</div>
        </div>
        <div class="content" v-else>
            <div v-if="this.courseType === 2" class="des">
                Hi，欢迎进入小花生数学启蒙绘本阅读Program！在使用期间，有任何问题或者建议，欢迎微信联系小花生客服哦～
                <br/><br/>长按下图保存，进入微信识别即可
            </div>
            <div v-else class="des">
                获取课程音频{{this.courseId === 1 ? '和练习纸资源' : ''}}，请添加【小花生班主任】微信好友哦！
            </div>
            <div class="icon_qrcode">
                <img v-if="this.courseType === 2" src="@/Images/icon_qrcode_math_start.png" alt="" />
                <img v-else src="@/Images/icon_qrcode_big5.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                courseId: parseInt(this.$route.query.courseId),
                courseType: parseInt(this.$route.query.courseType), // 1-大猫，2-Math Start
            }
        },
        methods: {
            geneBaiduUrl: function () {
                let that = this;
                let strUrl = "";

                switch (that.courseId) {
                    case 1:
                        strUrl = "https://pan.baidu.com/s/1WlvriLiOBe4XU6Z-0RFlJg";
                        break;
                    case 2:
                        strUrl = "https://pan.baidu.com/s/1NHwylGqhFt8d7pmhZpOCPQ";
                        break;
                    case 3:
                        strUrl = "https://pan.baidu.com/s/1do_zEswUQxmccVfSDyn0gg";
                        break;
                    default:
                        break;
                }

                if (that.isEmpty(strUrl)) {
                    return "";
                }

                return "<a href='" + strUrl + "'>点击这里 ➡️➡️ 进入百度云盘直接下载</a>";
            },
            geneBaiduCode: function () {
                let that = this;

                switch (that.courseId) {
                    case 1:
                        return "g993";
                    case 2:
                        return "mrrt";
                    case 3:
                        return "6kg3";
                    default:
                        return "";
                }
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            showStatusWhite:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (vPlatform === 4) {
                    window.note.changeStatusStyle(status);
                }
            },
        },
        beforeCreate() {
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        },
    }
</script>

<style scoped>
    .navigation {
        position: fixed;
        width: 100%;
        z-index: 998;
        background-color: white;
    }

    .navigation .left img {
        width: 22px;
        height: 22px;
    }

    .course_main {
        background-color: white;
        min-height: 100vmax;
    }
    .course_main .left {
        float: right;
        margin-right: 5px;
        color: #333333;
    }
    .course_main .title {
        color: #333333;
        font-size: 18px;
    }
    .content .des {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 20px;
        color: #333333;
        font-size: 16px;
    }
    .icon_qrcode {

    }
    .icon_qrcode img {
        width: 70vmin;
        margin-left: 15vmin;
        margin-top: 30px;
    }

    .content .ws_title {
        width: 100%;
        margin-top: 30px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
    }

    .content .ws_des {
        margin-left: 20px;
        margin-top: 30px;
        font-size: 16px;
        color: #333333;
    }
    .content .ws_url {
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 5px;
        font-size: 16px;
        color: #333333;
        word-wrap: break-word;
        word-break: normal;
    }
    .content .ws_url>>> a {
        color: #2483d5;
    }
    .content .ws_code {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 16px;
        color: #333333;
    }

</style>
